import { Container, H2, Text, FlexContainer } from "@carrotfertility/carotene"
import styled from "styled-components"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { IlloUnderwaterChecklist } from "components/views/atoms/Illustrations"
import { RoundedRectangle } from "components/views/atoms/roundedrectangle/RoundedRectangle"
import { RowItem } from "components/views/atoms/row/Row"
import React from "react"
import { useSelector } from "react-redux"
import { getCarrotLite } from "reducers/companyInfo"

const ImageContainer = styled.div({
  display: "flex",
  flex: 0
})

const HeroMainContent = styled.div({
  display: "flex",
  flex: 1
})

const EXPERIENCE_TYPE_TO_COPY = {
  CORE: {
    title: "Your Carrot Plan",
    body:
      "When you're ready to access experts, providers, and more, tell us about your family-forming journey and we'll craft a free, personalized plan to support you."
  },
  PRO: {
    title: "Your Carrot Plan",
    body:
      "When you're ready to access Carrot funds, experts, providers, and more, tell us about your family-forming journey and we'll craft a free, personalized plan to support you."
  }
}
// This should be able to be handled by a carotene component, but can't
// This should eventually be followed up on
function HeroWithImage({ children, image, spacing }): JSX.Element {
  return (
    <FlexContainer justifyContent="flex-end" wrap="wrap" direction="row-reverse">
      <ImageContainer>{image}</ImageContainer>
      <Container width={spacing}>{""}</Container>
      <HeroMainContent>{children}</HeroMainContent>
    </FlexContainer>
  )
}

export function GetCarrotPlanHero(): JSX.Element {
  const isCarrotCore = useSelector(getCarrotLite)

  const { title, body } = isCarrotCore ? EXPERIENCE_TYPE_TO_COPY.CORE : EXPERIENCE_TYPE_TO_COPY.PRO
  return (
    <RoundedRectangle backgroundColor="dark-blue">
      <HeroWithImage
        spacing="24px"
        image={
          <Container width="228px">
            <IlloUnderwaterChecklist />
          </Container>
        }
      >
        <RowItem minWidth="239px">
          <Container stack="medium">
            <H2 stack="tiny" variant="secondary">
              {title}
            </H2>
            <Text size="small" variant="light">
              {body}
            </Text>
          </Container>
          <ButtonPrimary to="/carrot-plans/about-you">Get your Carrot Plan</ButtonPrimary>
        </RowItem>
      </HeroWithImage>
    </RoundedRectangle>
  )
}
